module.exports = __webpack_public_path__ + "media/images/social-media-tumb-1eea7022931e9615e042d949d31d76c6.jpg";